export const coverageSortingColumns = [
    'policyNumber',
    'insuredCompany',
    'debtor',
    'debtorCompany',
    'coverageId',
    'requestedAmount',
    'acceptedAmount',
    'requestDate',
    'endDate',
    'decisionDate',
    'status',
    'acceptanceRate',
];
